import { render, staticRenderFns } from "./detailsTalk.vue?vue&type=template&id=53e67d3a&scoped=true&"
import script from "./detailsTalk.vue?vue&type=script&lang=js&"
export * from "./detailsTalk.vue?vue&type=script&lang=js&"
import style0 from "./detailsTalk.vue?vue&type=style&index=0&id=53e67d3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e67d3a",
  null
  
)

export default component.exports